import { render, staticRenderFns } from "./IndexChartBar.vue?vue&type=template&id=145afee4&scoped=true"
import script from "./IndexChartBar.vue?vue&type=script&lang=js"
export * from "./IndexChartBar.vue?vue&type=script&lang=js"
import style0 from "./IndexChartBar.vue?vue&type=style&index=0&id=145afee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145afee4",
  null
  
)

export default component.exports